import { getClientOrganization } from "@src/redux/index";
import { Button, Col, Collapse, Form, FormInstance, Modal, Row } from "antd";
import React, { useContext, useEffect, useMemo, useState } from "react";
import LevelForm from "./LevelForm";
import { useTranslation } from "react-i18next";
import { getUuid } from "@src/helpers/functions";
import LevelComponent from "./LevelComponent";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { DndContext, DragEndEvent } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { IoMdAddCircle } from "react-icons/io";
import { useSelector } from "react-redux";

type Props = {
  form: FormInstance;
  setLevels: any;
};

const ClientLevel = (props: Props) => {
  const { form, setLevels } = props;
  const [levelList, setLevelList] = useState<any[]>([
    {
      id: getUuid(),
      name: "",
      fieldType: "select",
      removableLevelAttributeIdList: [],
    },
  ]);
  const { t } = useTranslation();
  const { result: getClientOrganizationResult } = useSelector(
    getClientOrganization
  );

  const handleAdd = () => {
    setLevelList([
      ...levelList,
      {
        id: getUuid(),
        name: "",
        fieldType: "select",
        removableLevelAttributeIdList: [],
      },
    ]);
  };

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active.id !== over?.id) {
      setLevelList((prevState) => {
        // Move the dragged item
        const activeIndex = prevState.findIndex(
          (record) => record.id === active.id
        );
        const overIndex = prevState.findIndex(
          (record) => record.id === over?.id
        );
        const updatedList = arrayMove(prevState, activeIndex, overIndex);

        const lastTrueIndex = updatedList.reduce((lastIndex, item, index) => {
          return item.allowKitAssign ? index : lastIndex;
        }, -1);

        return updatedList.map((item, index) => {
          return {
            ...item,
            allowKitAssign: index <= lastTrueIndex,
          };
        });
      });
    }
  };

  useEffect(() => {
    if (levelList.length > 0) {
      setLevels(levelList);
    } else {
      setLevels([
        {
          name: "",
          id: getUuid(),
          isMandatory: false,
          priorityOrder: 1,
        },
      ]);
    }
  }, [levelList]);
  useEffect(() => {
    const rootLevelList = getClientOrganizationResult?.rootLevelList ?? [];

    if (rootLevelList.length > 0) {
      setLevelList(
        [...rootLevelList].sort(
          (a, b) => Number(a.orderNumber || 0) - Number(b.orderNumber || 0)
        )
      );
    }
  }, [getClientOrganizationResult]);

  return (
    <>
      {/* <Collapse >
      <Collapse.Panel
        header={ */}
      <div className="level-title-container">
        <h4>{t("levels")}</h4>
        <Button onClick={handleAdd} icon={<IoMdAddCircle size={20} />} />
      </div>
      {/* }
        key={0}
        showArrow={false}
        
      > */}
      <div className="level-list-container">
        <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
          <SortableContext
            items={levelList.map((item, index) => item?.id || "")}
            strategy={verticalListSortingStrategy}
          >
            <LevelComponent
              level={levelList}
              setLevelList={setLevelList}
            />
          </SortableContext>
        </DndContext>
      </div>
      {/* </Collapse.Panel>
    </Collapse> */}
    </>
  );
};

export default ClientLevel;
